const code = '//Code\nconsole.log("Hello World");';

export default code;
